const STOCK_CSV_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQ5WLmc8ZIgIm5_whNtGaZojP54VI4zaGiIVsxPVl1W5qZze4JI6VGTfhHUIwj-80zqndM0KvvPmp5_/pub?gid=0&single=true&output=csv';

// Cache stock data for 5 minutes
let stockCache = null;
let cacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds

/**
 * Parse CSV data into stock object
 * Expected CSV format:
 * El Mesias,S,1
 * ,M,1
 * ,L,1
 * Navajitas,S,2
 * ,M,5
 * ,L,3
 */
function parseStockCSV(csvText) {
    const lines = csvText.trim().split('\n');
    const stock = {};
    let currentProduct = null;

    lines.forEach(line => {
        const [product, size, quantity] = line.split(',').map(s => s.trim());

        // Update current product if product name is present
        if (product) {
            currentProduct = product;
        }

        // Initialize product object if needed
        if (currentProduct && !stock[currentProduct]) {
            stock[currentProduct] = {};
        }

        // Add size and quantity
        if (currentProduct && size && quantity !== undefined) {
            stock[currentProduct][size] = parseInt(quantity, 10);
        }
    });

    return stock;
}

/**
 * Fetch stock data from Google Sheets CSV
 * Returns object with format:
 * {
 *   "El Mesias": { "S": 1, "M": 1, "L": 1 },
 *   "Navajitas": { "S": 2, "M": 5, "L": 3 }
 * }
 */
export async function fetchStock() {
    // Return cached data if available and fresh
    const now = Date.now();
    if (stockCache && cacheTimestamp && (now - cacheTimestamp < CACHE_DURATION)) {
        return stockCache;
    }

    try {
        const response = await fetch(STOCK_CSV_URL);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const csvText = await response.text();
        const stock = parseStockCSV(csvText);

        // Update cache
        stockCache = stock;
        cacheTimestamp = now;

        return stock;
    } catch (error) {
        console.error('Error fetching stock:', error);
        // Return empty stock on error
        return {};
    }
}

/**
 * Get stock for a specific product
 * @param {string} productTitle - Product title (e.g., "El Mesías")
 * @returns {Promise<Object>} Stock object with sizes and quantities
 */
export async function getProductStock(productTitle) {
    const allStock = await fetchStock();
    // Match product title (handle accent variations)
    const normalizedTitle = productTitle.replace('í', 'i'); // "El Mesías" -> "El Mesias"
    return allStock[normalizedTitle] || {};
}
